import React, { Component } from 'react';
import ModalContentConfigFormInputs from './ModalContentConfigFormInputs';

export class ModalContentConfigForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedOption: 'option1',
            save: {},
            restore: {}
        };

        this.handleOptionChange = this.handleOptionChange.bind(this);
    }

    handleOptionChange(event) {
        this.setState(
            {
                selectedOption: event.target.value
            },
            () => {
                this.props.onChange(this.state);
            }
        );
    }

    render() {
        const contentTypeUpperFirst = _.startCase(_.toLower(this.props.contentType));

        return (
            <div id="add-theme-level" className="row">
                <div id="add-theme-name-theme" className="col-xs-12">
                    <div className="spark-toggle-group">
                        <fieldset className="row">
                            <label className="col-xs-12 spark-radio">
                                <input
                                    checked={this.state.selectedOption === 'option1'}
                                    className="spark-radio__input"
                                    onChange={this.handleOptionChange}
                                    type="radio"
                                    value="option1"
                                />
                                <span className="spark-radio__box"></span>
                                <span className="spark-label">{`This ${contentTypeUpperFirst} only`}</span>
                            </label>
                        </fieldset>
                    </div>
                    {this.state.selectedOption === 'option1' && (
                        <div style={{ marginBottom: 30 }}>
                            <ModalContentConfigFormInputs
                                errorForm={this.props.errorForm}
                                values={this.state.restore}
                                type="restore"
                                onChange={values => {
                                    this.setState(
                                        {
                                            restore: values
                                        },
                                        () => {
                                            this.props.onChange(this.state);
                                        }
                                    );
                                }}
                            />
                        </div>
                    )}
                </div>
                <div id="add-theme-name-theme" className="col-xs-12">
                    <div className="spark-toggle-group">
                        <fieldset className="row">
                            <label className="col-xs-12 spark-radio">
                                <input
                                    className="spark-radio__input"
                                    type="radio"
                                    value="option2"
                                    checked={this.state.selectedOption === 'option2'}
                                    onChange={this.handleOptionChange}
                                />
                                <span className="spark-radio__box"></span>
                                <span className="spark-label">{`A new ${contentTypeUpperFirst}`}</span>
                            </label>
                        </fieldset>
                    </div>
                    {this.state.selectedOption === 'option2' && (
                        <ModalContentConfigFormInputs
                            values={this.state.save}
                            contentType={contentTypeUpperFirst}
                            errorForm={this.props.errorForm}
                            type="save"
                            onChange={values => {
                                this.setState(
                                    {
                                        save: values
                                    },
                                    () => {
                                        this.props.onChange(this.state);
                                    }
                                );
                            }}
                        />
                    )}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/modalContent/ModalContentConfigForm.js